import { useCallback } from "react";
import { IWizardConfig, WizardMode } from "../../../wizard/types";
import useBranchQueries from "../../../school/hooks/useBranchQueries";
import branchFormValidator from "../validators/validator";
import BranchForm from "../components/BranchForm";
import { useSchoolId } from "../../../school/hooks/useSchoolId";
import { getName } from "country-list";
import { EducationType } from "../../../school/constants/types";
import { useProfile } from "../../../user/hooks/useProfile";

export function useAddBranchConfig(): IWizardConfig {
  const { fetchCreate } = useBranchQueries();
  const profile = useProfile();
  const schoolId = useSchoolId();
  const schoolCountry = profile.school.country;
  const isLanguageSchool = profile.school.type.id === EducationType.Language;

  const parseToBackEndModel = (data, schoolId) => ({
    schoolId,
    country: data.country?.code,
    state: data.state ? data.state.trim() : null,
    city: data.city.trim(),
    address: data.address.trim(),
    zip: data.zip.trim(),
  });

  const addBranch = useCallback(
    async (data) => {
      return await fetchCreate(parseToBackEndModel(data, schoolId));
    },
    [fetchCreate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    steps: [
      {
        width: "552px",
        titleConfig: {
          titleText: "Add a Branch",
          info: "If you have more than 1 branch you need to create addresses first after you need to assign each completed program to each branch.",
        },
        content: BranchForm,
        validator: branchFormValidator,
      },
    ],
    saveCallback: addBranch,
    getInitialData: async () => ({
      ...(isLanguageSchool && {
        country: {
          code: schoolCountry,
          name: getName(schoolCountry),
        },
      }),
    }),
    submitButtonText: "Save",
    cancelButtonText: "Close",
    mode: WizardMode.Create,
  };
}
